import { colors } from '../../../theme';

const dataGridStyle = (theme) => ({
  studentDetails: {
    textAlign: 'left',
    paddingTop: '0.2vw',
    '& .MuiDataGrid-virtualScrollerRenderZone': {
      paddingLeft: '6vw',
    },
    '& .MuiDataGrid-row': {
      alignItems: 'center',
    },
    '& .MuiDataGrid-columnHeadersInner': {
      paddingLeft: '6vw',
    },
    '@media (max-width: 1920px)': {
      '& .MuiDataGrid-virtualScrollerRenderZone': {
        paddingLeft: '4.5vw',
      },
      '& .MuiDataGrid-columnHeadersInner': {
        paddingLeft: '4.5vw',
      },
    },
    '@media (max-width: 1500px)': {
      '& .MuiDataGrid-virtualScrollerRenderZone': {
        paddingLeft: '2.5vw',
      },
      '& .MuiDataGrid-columnHeadersInner': {
        paddingLeft: '2.5vw',
      },
    },
    '@media (max-width: 1250px)': {
      '& .MuiDataGrid-virtualScrollerRenderZone': {
        paddingLeft: '0.5vw',
      },
      '& .MuiDataGrid-columnHeadersInner': {
        paddingLeft: '0.5vw',
      },
    },
    '& svg': {
      '@media (min-width: 1200px)': {
        width: '1vw !important',
        height: '1vw !important',
      },
      [theme.breakpoints.down('md')]: {
        width: '20px !important',
        height: '20px !important',
      },
    },
    '& .MuiDataGrid-virtualScroller': {
      overflowY: 'scroll !important',
    },
    '& .MuiDataGrid-cell': {
      border: 'none',
    },
    '& .MuiDataGrid-cell:focus-within': {
      outline: 'none',
    },
    '& .MuiDataGrid-root': {
      minHeight: '5vw !important',
      border: 'none',
    },
    '& .MuiDataGrid-footerContainer': {
      border: 'none',
    },
    '& .fa-sort-down': {
      marginBottom: '0.5vw',
    },
    '& .fa-sort-up': {
      marginTop: '0.5vw',
    },
    '& .MuiDataGrid-columnHeader[data-role="courseName"]': {
      width: '5vw',
    },
    '& .MuiDataGrid-pinnedColumnHeaders': {
      '@media (max-width: 1200px)': {
        height: 'auto !important',
      },
    },
  },
  dataGrid: {
    '& div[role="columnheader"]:last-child': {
      '& .MuiDataGrid-columnHeaderDraggableContainer': {
        flexDirection: 'row',
      },
      '& .MuiDataGrid-columnHeaderTitleContainer': {
        flexDirection: 'row',
      },
    },
    '& .MuiDataGrid-row': {
      '@media (min-width: 1200px)': {
        minHeight: '4vw !important',
        maxHeight: '4vw !important',
      },
    },
    '& .MuiDataGrid-root': {
      outline: 'none !important',
      border: 'none !important',
    },
    '& .MuiDataGrid-iconButtonContainer': {
      visibility: 'visible',
      width: '0 !important',
    },
    '& .MuiDataGrid-columnHeaders': {
      borderBottom: '4px solid #025EE6 !important',
      borderTop: 'none',
      fontFamily: 'Roboto,Helvetica,Arial,sans-serif',
      fontStyle: 'bold',
      '@media (min-width: 1200px)': {
        fontSize: '0.9vw',
        maxHeight: '4vw !important',
      },
      lineHeight: '63px !important',
      color: colors.actionIconsColor,
      minHeight: '3vw !important',
      zIndex: '111 !important',
      backgroundColor: '#fff  !important',
      '@media (max-width: 1500px)': {
        minHeight: '4vw !important',
        maxHeight: '6vw !important',
      },
      '@media (max-width: 900px)': {
        minHeight: '56px !important',
        maxHeight: '56px !important',
        lineHeight: '56px !important',
      },
    },
    '& .MuiDataGrid-iconSeparator': {
      visibility: 'hidden',
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      fontWeight: 'bold',
      fontSize: '0.9vw',
      justifyContent: 'space-evenly',
      [theme.breakpoints.down('md')]: {
        fontSize: 11,
      },
    },
    '& .MuiDataGrid-virtualScroller': {
      '@media (min-width: 1200px)': {
        maxHeight: '41vw !important',
        overflowY: 'auto !important',
      },
      '@media (min-width: 768px) and (max-width: 1200px)': { marginTop: '6vw !important' },
      overflowX: 'scroll !important',
      marginTop: '4vw !important',
      '@media (max-width: 900px)': {
        marginTop: '65px !important',

      },
    },
    '&.MuiDataGrid-root .MuiDataGrid-cell:focus': {
      outline: 'none',
    },
    '&.MuiDataGrid-root .MuiDataGrid-columnHeaderTitle:focus': {
      outline: 'none',
    },
    '&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus-within': {
      outline: 'none !important',
    },

    '& .marksHeader, .marksCell': {
      '& .MuiDataGrid-columnHeaderTitleContainer': {
        alignItems: 'center',
        justifyContent: 'space-around',
      },
      '@media (min-width: 1200px)': {
        width: '8vw !important',
        minWidth: '8vw !important',
        maxWidth: '8vw !important',
        fontSize: '1vw',
        minHeight: '4vw !important',
        maxHeight: '10vw !important',
        cursor: 'pointer',
      },
    },
    '& .curricularCell': {
      '& .MuiDataGrid-columnHeaderTitleContainer': {
        alignItems: 'center',
        justifyContent: 'space-around',
      },
      '@media (min-width: 1200px)': {
        width: '8vw !important',
        minWidth: '8vw !important',
        maxWidth: '8vw !important',
        fontSize: '1vw',
        minHeight: '4vw !important',
        maxHeight: '10vw !important',
        cursor: 'pointer',

      },
    },
    '& .borderCell': {
      '& .MuiDataGrid-columnHeaderTitleContainer': {
        alignItems: 'center',
        justifyContent: 'space-around',
      },
      '@media (min-width: 1200px)': {
        width: '8vw !important',
        minWidth: '8vw !important',
        maxWidth: '8vw !important',
        fontSize: '1vw',
        minHeight: '4vw !important',
        maxHeight: '10vw !important',
        cursor: 'pointer',
        borderRight: '0.1vw solid #ccc',
      },
    },
    '& .marksQ3Header, .marksQ3Cell': {
      marginLeft: '-9px',
      justifyContent: 'center !important',
      '& .MuiDataGrid-columnHeaderTitleContainer': {
        justifyContent: 'center !important',
        alignItems: 'center',
      },
      '@media (min-width: 1200px)': {
        width: '8vw !important',
        minWidth: '8vw !important',
        maxWidth: '8vw !important',
        fontSize: '0.9vw',
        minHeight: '4vw !important',
        maxHeight: '10vw !important',
        cursor: 'pointer',
      },
    },
    '& .marksGreenCell': {
      '& span': {
        textTransform: 'none !important',
        color: '#f3f8fe !important',
        boxShadow: '0 4px 4px -2px hsl(0deg 0% 65% / 25%)',
        boxSizing: 'border-box',
        height: '2.7vw',
        minWidth: '3.1vw',
        maxWidth: '3.1vw',
        fontFamily: 'inherit',
        padding: '0.8vw',
        borderRadius: '0.5vw !important',
        background: colors.lightGreen,
        fontSize: '0.9vw',
        cursor: 'pointer',
        [theme.breakpoints.down('md')]: {
          height: 30,
        },
      },
    },
    '& .marksYellowCell': {
      '& span': {
        textTransform: 'none !important',
        color: '#f3f8fe !important',
        boxShadow: '0 4px 4px -2px hsl(0deg 0% 65% / 25%)',
        boxSizing: 'border-box',
        height: '2.7vw',
        minWidth: '3.1vw',
        maxWidth: '3.1vw',
        fontFamily: 'inherit',
        padding: '0.8vw',
        borderRadius: '0.5vw !important',
        background: colors.yellow,
        fontSize: '0.9vw',
        cursor: 'pointer',
        [theme.breakpoints.down('md')]: {
          height: 30,
        },
      },
    },
    '& .marksRedCell': {
      '& span': {
        textTransform: 'none !important',
        color: '#f3f8fe !important',
        boxShadow: '0 4px 4px -2px hsl(0deg 0% 65% / 25%)',
        boxSizing: 'border-box',
        height: '2.7vw',
        minWidth: '3.1vw',
        maxWidth: '3.1vw',
        fontFamily: 'inherit',
        padding: '0.8vw',
        borderRadius: '0.5vw !important',
        background: colors.red,
        fontSize: '0.9vw',
        cursor: 'pointer',
        [theme.breakpoints.down('md')]: {
          height: 30,
        },
      },
    },
    '& .marksHeaderSpan2': {
      marginLeft: '6px',
      '& .MuiDataGrid-columnHeaderTitleContainer': {
        justifyContent: 'center !important',
        marginLeft: '-15px',
      },
      '@media (min-width: 1200px)': {
        width: '8vw !important',
        minWidth: '8vw !important',
        maxWidth: '8vw !important',
        fontSize: '0.9vw',
        minHeight: '4vw !important',
        maxHeight: '10vw !important',
        cursor: 'pointer',
        left: '6px',
      },
      '& .MuiDataGrid-columnHeaderDraggableContainer': {
        padding: '4px 13px',
        '@media (min-width: 1200px)': {
          padding: '4px 8px',
        },
      },
      '& span': {
        position: 'absolute',
        top: '-25px',
        zIndex: 1,
        cursor: 'pointer',
        left: '6px',
        '@media (min-width: 1200px)': {
          top: '-20px',
        },
        '@media (max-width: 1500px)': {
          top: '-16px',
        },
        '@media (max-width: 1300px)': {
          left: '10px',
          top: '-14px',
        },
      },
    },
    '& .marksHeaderSpan': {
      marginLeft: '-10px',
      '& .MuiDataGrid-columnHeaderTitleContainer': {
        justifyContent: 'center !important',
      },
      '@media (min-width: 1200px)': {
        width: '8vw !important',
        minWidth: '8vw !important',
        maxWidth: '8vw !important',
        fontSize: '0.9vw',
        minHeight: '4vw !important',
        maxHeight: '10vw !important',
        cursor: 'pointer',
        left: '6px',
      },
      '& .MuiDataGrid-columnHeaderDraggableContainer': {
        padding: '4px 13px',
        '@media (min-width: 1200px)': {
          padding: '4px 8px',
        },
      },
      '& span': {
        position: 'absolute',
        top: '-25px',
        zIndex: 1,
        cursor: 'pointer',
        left: '35px',
        '@media (min-width: 1200px)': {
          top: '-20px',
        },
        '@media (max-width: 1500px)': {
          top: '-16px',
        },
        '@media (max-width: 1300px)': {
          left: '10px',
          top: '-14px',
        },
      },
    },
    '& .homeworkHeaderSpan': {
      marginLeft: '-15px',
      '& .MuiDataGrid-columnHeaderTitleContainer': {
        justifyContent: 'center !important',
      },
      '@media (min-width: 1200px)': {
        width: '8vw !important',
        minWidth: '8vw !important',
        maxWidth: '8vw !important',
        fontSize: '1vw',
        minHeight: '4vw !important',
        maxHeight: '10vw !important',
        cursor: 'pointer',
        left: '9px',
      },
      '& .MuiDataGrid-columnHeaderDraggableContainer': {
        padding: '4px 13px',
        '@media (min-width: 1200px)': {
          padding: '4px 8px',
        },
      },
      '& span': {
        position: 'absolute',
        top: '-20px',
        zIndex: 1,
        cursor: 'pointer',
        left: '35px',
        '@media (max-width: 1200px)': {
          top: '-8px',
        },
        '@media (max-width: 1500px)': {
          top: '-16px',
        },
        '@media (max-width: 1300px)': {
          left: '-4px !important',
          top: '-14px',
        },
      },
    },
    '& .bonusHeaderSpan': {
      marginLeft: '-11px',
      '@media (min-width: 1200px)': {
        width: '8vw !important',
        minWidth: '8vw !important',
        maxWidth: '8vw !important',
        fontSize: '0.9vw',
        minHeight: '1.3vw !important',
        maxHeight: '10vw !important',
        cursor: 'pointer',
        left: '6px',
      },
      '& span': {
        position: 'absolute',
        top: '-20px',
        zIndex: 1,
        cursor: 'pointer',
        left: '9px',
        '@media (max-width: 1300px)': {
          top: '-14px',
        },
      },
    },
    '& .pictureHeader, .pictureCell': {
      '@media (min-width: 1200px)': {
        width: '5vw !important',
        minWidth: '5vw !important',
        maxWidth: '5vw !important',
        borderRadius: '50%',
        fontSize: '0.9vw',
      },
      '@media (max-width: 1199px)': {
        width: '80px !important',
        minWidth: '80px !important',
        maxWidth: '80px !important',
      },
      '& img': {
        '@media (min-width: 1200px)': {
          width: '3vw',
          height: '3vw',
        },
        '@media (max-width: 1200px)': {
          width: '50px',
          height: '50px',
        },
        borderRadius: '50%',
      },
    },
    '& .commonHeader, .commonCell': {
      '@media (min-width: 1200px)': {
        width: '9vw !important',
        minWidth: '10vw !important',
        maxWidth: '10vw !important',
        borderRadius: '50%',
        fontSize: '0.9vw',
        minHeight: '3vw !important',
        left: '0px',
      },
      '@media (max-width: 1199px)': {
        width: '120px !important',
        minWidth: '120px !important',
        maxWidth: '120px !important',
        borderRadius: '50%',
        minHeight: '3vw !important',
      },
    },
    '& .parentHeader, .parentCell': {
      '@media (min-width: 1200px)': {
        width: '9vw !important',
        minWidth: '10vw !important',
        maxWidth: '10vw !important',
        borderRadius: '50%',
        fontSize: '0.9vw',
        minHeight: '3vw !important',
        left: '10px',
      },
      '@media (max-width: 1199px)': {
        width: '120px !important',
        minWidth: '120px !important',
        maxWidth: '120px !important',
        borderRadius: '50%',
        minHeight: '3vw !important',
      },
    },
    '& .emailHeader, .emailCell': {
      '@media (min-width: 1200px)': {
        width: '25vw !important',
        minWidth: '10vw !important',
        maxWidth: '30vw !important',
        borderRadius: '50%',
        fontSize: '0.9vw',
        minHeight: '3vw !important',
        left: '0px',
      },
      '@media (max-width: 1199px)': {
        width: '300px !important',
        minWidth: '250px !important',
        maxWidth: '350px !important',
        borderRadius: '50%',
        minHeight: '3vw !important',
      },
    },
    '& .actionCells': {
      '@media (min-width: 1200px)': {
        width: '9vw !important',
        minWidth: '10vw !important',
        maxWidth: '10vw !important',
        borderRadius: '50%',
        fontSize: '0.9vw',
        minHeight: '3vw !important',
        marginLeft: '-15px',
      },
      '@media (max-width: 1199px)': {
        width: '120px !important',
        minWidth: '120px !important',
        maxWidth: '120px !important',
        borderRadius: '50%',
        minHeight: '3vw !important',
      },
    },
    '& .semesterActionCells': {
      '@media (min-width: 1200px)': {
        width: '9vw !important',
        minWidth: '10vw !important',
        maxWidth: '10vw !important',
        borderRadius: '50%',
        fontSize: '0.9vw',
        minHeight: '3vw !important',
        marginLeft: '-44px',
      },
      '@media (max-width: 1199px)': {
        width: '120px !important',
        minWidth: '120px !important',
        maxWidth: '120px !important',
        borderRadius: '50%',
        minHeight: '3vw !important',
      },
    },
    '& .quarterActionCells': {
      '@media (min-width: 1200px)': {
        width: '3vw !important',
        minWidth: '1vw !important',
        maxWidth: '5vw !important',
        borderRadius: '50%',
        fontSize: '1vw',
        minHeight: '3vw !important',
        marginLeft: '0px',
      },
      '@media (max-width: 1199px)': {
        width: '120px !important',
        minWidth: '120px !important',
        maxWidth: '120px !important',
        borderRadius: '50%',
        minHeight: '3vw !important',
      },
    },
    '& .semGradeHeader': {
      alignItems: 'center',
      justifyContent: 'space-around',
      marginLeft: '-15px',
      '@media (min-width: 1200px)': {
        width: '7vw !important',
        minWidth: '7vw !important',
        maxWidth: '7vw !important',
        borderRadius: '50%',
        fontSize: '0.9vw',
        minHeight: '3vw !important',
        left: '42px',
      },
    },
    '& .semGradeCell': {
      alignItems: 'center',
      marginLeft: '8px',
      '@media (min-width: 1200px)': {
        width: '6vw !important',
        minWidth: '6vw !important',
        maxWidth: '6vw !important',
        borderRadius: '50%',
        fontSize: '0.9vw',
        minHeight: '3vw !important',
        paddingLeft: '30px',
      },
    },
    '& .semGpaHeader': {
      alignItems: 'center',
      justifyContent: 'space-around',
      marginLeft: '4px',
      '@media (min-width: 1200px)': {
        width: '8vw !important',
        minWidth: '8vw !important',
        maxWidth: '8vw !important',
        borderRadius: '50%',
        fontSize: '0.9vw',
        minHeight: '3vw !important',
        left: '16px',
      },
    },
    '& .semGpaCell': {
      alignItems: 'center',
      marginLeft: '8px',
      '@media (min-width: 1200px)': {
        width: '6vw !important',
        minWidth: '6vw !important',
        maxWidth: '6vw !important',
        borderRadius: '50%',
        fontSize: '0.9vw',
        minHeight: '3vw !important',
      },
    },
    '& .quarterGpaCell': {
      alignItems: 'center',
      marginLeft: '0px',
      '@media (min-width: 1200px)': {
        width: '6vw !important',
        minWidth: '6vw !important',
        maxWidth: '6vw !important',
        borderRadius: '50%',
        fontSize: '0.9vw',
        minHeight: '3vw !important',
      },
    },
    '& .gradeHeader': {
      alignItems: 'center',
      justifyContent: 'space-around',
      marginLeft: '4px',
      '@media (min-width: 1200px)': {
        width: '6vw !important',
        minWidth: '6vw !important',
        maxWidth: '6vw !important',
        borderRadius: '50%',
        fontSize: '0.9vw',
        minHeight: '3vw !important',
        left: '20px',
      },
    },
    '& .gradeCell': {
      alignItems: 'center',
      marginLeft: '8px',
      '@media (min-width: 1200px)': {
        width: '6vw !important',
        minWidth: '6vw !important',
        maxWidth: '6vw !important',
        borderRadius: '50%',
        fontSize: '0.9vw',
        minHeight: '3vw !important',
        paddingLeft: '30px',
      },
    },
    '& .gpaHeader': {
      alignItems: 'center',
      justifyContent: 'space-around',
      marginLeft: '4px',
      '@media (min-width: 1200px)': {
        width: '6vw !important',
        minWidth: '6vw !important',
        maxWidth: '6vw !important',
        borderRadius: '50%',
        fontSize: '0.9vw',
        minHeight: '3vw !important',
        left: '-10px',
      },
    },
    '& .gpaCell': {
      alignItems: 'center',
      marginLeft: '8px',
      '@media (min-width: 1200px)': {
        width: '6vw !important',
        minWidth: '6vw !important',
        maxWidth: '6vw !important',
        borderRadius: '50%',
        fontSize: '0.9vw',
        minHeight: '3vw !important',
      },
    },
    '& .bonusCell': {
      '@media (min-width: 1200px)': {
        width: '8vw !important',
        minWidth: '8vw !important',
        maxWidth: '8vw !important',
        fontSize: '0.9vw',
        minHeight: '3vw !important',
      },
    },
    '& .bonusHeader': {
      '@media (min-width: 1200px)': {
        width: '9vw !important',
        minWidth: '7.5vw !important',
        maxWidth: '7.5vw !important',
        fontSize: '0.9vw',
        minHeight: '3vw !important',
      },
    },
    '& .phoneNumberHeader, .phoneNumberCell': {
      '@media (min-width: 1200px)': {
        width: '10vw !important',
        minWidth: '10vw !important',
        maxWidth: '10vw !important',
        borderRadius: '50%',
        fontSize: '0.9vw',
        minHeight: '3vw !important',
      },
      '@media (max-width: 1199px)': {
        width: '120px !important',
        minWidth: '120px !important',
        maxWidth: '120px !important',
        borderRadius: '50%',
        minHeight: '3vw !important',
      },
    },
    '& .studentNameHeader, .studentNameCell': {
      '@media (min-width: 1200px)': {
        width: '10vw !important',
        minWidth: '10vw !important',
        maxWidth: '10vw !important',
        borderRadius: '50%',
        fontSize: '0.9vw',
        minHeight: '3vw !important',
      },
      '@media (max-width: 1199px)': {
        width: '110px !important',
        minWidth: '110px !important',
        maxWidth: '110px !important',
      },
    },
    '& .courseHeader, .courseCell': {
      '@media (min-width: 1200px)': {
        width: '12vw !important',
        minWidth: '7vw !important',
        maxWidth: '7vw !important',
        borderRadius: '50%',
        fontSize: '0.9vw',
        minHeight: '3vw !important',
      },
    },
    '& .newReturningHeader, .newReturningCell': {
      marginLeft: '-11px',
      '@media (min-width: 1200px)': {
        width: '8vw !important',
        minWidth: '8vw !important',
        maxWidth: '8vw !important',
        fontSize: '1vw',
        minHeight: '4vw !important',
        maxHeight: '10vw !important',
        cursor: 'pointer',
        lineHeight: '4vw !important',
      },
      '& span': {
        position: 'absolute',
        top: '-20px',
        zIndex: 1,
        cursor: 'pointer',
        left: '11px',
        '@media (max-width: 1300px)': {
          top: '-14px',
        },
      },
    },
    '& .numberHeader, .numberCell': {
      '@media (min-width: 1200px)': {
        width: '5vw !important',
        minWidth: '5vw !important',
        maxWidth: '5vw !important',
        fontSize: '0.9vw',
        minHeight: '3vw !important',
        maxHeight: '3vw !important',
      },
    },

    '& .actionCell': {
      '@media (min-width: 1200px)': {
        width: '10vw !important',
        minWidth: '10vw !important',
        maxWidth: '10vw !important',
        fontSize: '0.9vw',
        minHeight: '3vw !important',
      },
      '& svg': {
        '@media (min-width: 1200px)': {
          width: '1.5vw !important',
          height: '1.4vw !important',
        },
        [theme.breakpoints.down('md')]: {
          width: '20px !important',
          height: '20px !important',
        },
      },
    },
  },
});

export default dataGridStyle;
